import React from 'react';
import ls from 'local-storage';
import { Modal, Tabs, Tab, Table, ProgressBar, Panel, Row, OverlayTrigger, Tooltip ,Alert } from 'react-bootstrap';
import Images from '../components/images';
import { MyContext } from '../InitialSetup/MyProvider';
import WSManager from "../WSHelper/WSManager";
import * as WSC from "../WSHelper/WSConstants";
import * as AppLabels from "../helper/AppLabels";
import InfiniteScroll from 'react-infinite-scroll-component';
import CountdownTimer from '../views/CountDownTimer';
import { Utilities, _Map, _filter } from '../Utilities/Utilities';
import * as Constants from "../helper/Constants";
import util from 'util';
import { SportsIDs } from "../JsonFiles";
import CollectionInfoModal from "../Modals/CollectionInfo";
import { getContestDetails, getContestDetailsMultiGame, getUserContestJoinCount, getContestUserList, getFixtureMiniLeague, getMiniLeagueDetails,getContestDetailsNetworkfantasy,getContestUserListNetworkfantasy,getUserContestJoinCountNetworkfantasy, getTDSNotes } from '../WSHelper/WSCallings';
import { MomentDateComponent } from '../Component/CustomComponent';
import { MATCH_TYPE } from "../helper/Constants";
import { NoDataView } from '../Component/CustomComponent';
import { FtpPrizeComponent } from '../Component/FreeToPlayModule';
import { ALL } from 'dns';


var masterDataResponse = null;
var fantasyListArray = null;
var selectedSportsVar = null;
var isTimerOver = false;

var hasMore = false;

export default class ContestDetailModal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            prizeList: [],
            ContestDetail: "",
            merchandiseList: [],
            MiniLeagueList: [],
            miniLeagueprizeList: [],
            miniLeagueMerchandiseList: [],
            bonus_scoring_rules: [],
            normal_scoring_rules: [],
            strike_scoring_rules: [],
            economy_scoring_rules: [],
            pitching_scoring_rules: [],
            hitting_scoring_rules: [],
            prizeDistributionDetail: [],
            isMiniLeaguePrize: '',
            MiniLeagueData: '',
            userList: [],
            playerCount: 0,
            joinBtnVisibility: false,
            isLoading: false,
            limit: 20,
            sportsSelected: Constants.AppSelectedSport,
            userJoinCount: WSManager.loggedIn() ? -1 : 0,
            contestStatus: this.props.contestStatus,
            showCollectionInfo: false,
            total_user_joined: this.props.OpenContestDetailFor ? this.props.OpenContestDetailFor.total_user_joined : 0,
            page_no: 1,
            maxcurrentStatus: true,
            season_game_uid: '',
            showError: false,
            isPrivateContest: 0,
            showMaxToggle: true,
            tdsNotesObj: {},
        };
    }

    convertIntoWhole = (x) => {
        var no = Math.round(x)
        return no;
    }

    ShowProgressBar = (join, total) => {
        return join * 100 / total;
    }

    isMaximumSelected = (isSelected) => {
        this.setState({ maxcurrentStatus: isSelected });
    }

    /**
    * 
    * @description method to display collection info model.
    */
    CollectionInfoShow = (event) => {
        event.stopPropagation();
        this.setState({
            showCollectionInfo: true
        }, () => {
        });
    }
    /**
     * 
     * @description method to hide collection info model.
     */
    CollectionInfoHide = () => {
        this.setState({
            showCollectionInfo: false,
        });
    }

    componentDidMount() {

        this.ContestDetail(this.props.OpenContestDetailFor);
        this.getMasterDataFromLS();
        if (Constants.SELECTED_GAMET == Constants.GameType.Free2Play) {
            this.props.LobyyData.season_game_uid && this.getFixtureMiniLeagueApi();
        }
        this.getTDSTextFromS3();
    }

    async getTDSTextFromS3() {
        var tdsText = await getTDSNotes();
        this.setState({ tdsNotesObj: tdsText });
    }

    getMasterDataFromLS() {
        selectedSportsVar = Constants.AppSelectedSport;
        masterDataResponse = Utilities.getMasterData()
        if (masterDataResponse && masterDataResponse != null) {
            fantasyListArray = masterDataResponse.fantasy_list;
            for (var obj of fantasyListArray) {
                if (selectedSportsVar == obj.sports_id) {
                    this.setState({
                        playerCount: obj.team_player_count
                    })
                    break;
                }
            }
        }
    }

    ContestDetail = async (data) => {
        var param = {
            "contest_id": data.contest_id,
        }
        this.setState({ isLoading: true })
        var api_response_data = await ((this.props.OpenContestDetailFor && this.props.OpenContestDetailFor.is_network_contest && this.props.OpenContestDetailFor.is_network_contest == 1) ? getContestDetailsNetworkfantasy(param) : Constants.SELECTED_GAMET == Constants.GameType.MultiGame ? getContestDetailsMultiGame(param) : getContestDetails(param));

        if (api_response_data) {
            this.setState({ isLoading: false })

            let normal_scoring_rules = [];
            let bonus_scoring_rules = [];
            let strike_scoring_rules = [];
            let economy_scoring_rules = [];
            let pitching_scoring_rules = [];
            let hitting_scoring_rules = [];
            _Map(api_response_data.scoring_rules, (o) => {
                let masterSID = o.master_scoring_category_id;
                let isNormal = o.scoring_category_name==='normal'
                if(masterSID === '14' || masterSID === '18' ||
                masterSID === '19' || masterSID === '20' ||
                masterSID === '23' || masterSID === '24' ||
                masterSID === '25' || masterSID === '27'|| masterSID==='30' || isNormal){
                    normal_scoring_rules.push(o)
                }else if(masterSID === '15' || masterSID === '26'){
                    bonus_scoring_rules.push(o)
                }else if(masterSID === '17'){
                    strike_scoring_rules.push(o)
                }else if(masterSID === '16'){
                    economy_scoring_rules.push(o)
                }else if(masterSID === '21'){
                    pitching_scoring_rules.push(o)
                }else if(masterSID === '22'){
                    hitting_scoring_rules.push(o)
                }
                
            })

            if (this.props.activeTabIndex == 4) {
                this.getUserList(this.props.OpenContestDetailFor, 0);
            }
            this.setState({
                season_game_uid: api_response_data.season_game_uid,
                ContestDetail: api_response_data,
                normal_scoring_rules: normal_scoring_rules,
                bonus_scoring_rules: bonus_scoring_rules,
                strike_scoring_rules: strike_scoring_rules,
                economy_scoring_rules: economy_scoring_rules,
                pitching_scoring_rules: pitching_scoring_rules,
                hitting_scoring_rules: hitting_scoring_rules,
                prizeDistributionDetail: api_response_data.prize_distibution_detail,
                prizeList: api_response_data.prize_distibution_detail,
                merchandiseList: api_response_data.merchandise,
                isPrivateContest: api_response_data.is_private || 0,
            }, () => {
                !this.props.LobyyData.season_game_uid && Constants.SELECTED_GAMET == Constants.GameType.Free2Play &&
                    this.getFixtureMiniLeagueApi();
                let prizeListVar = _filter(api_response_data.prize_distibution_detail, (o) => {
                    return o.max_value != o.min_value;
                })
                // let showMaxToggle = prizeListVar && prizeListVar.length > 0;
                let minDiff = Utilities.minuteDiffValue({ date: api_response_data.game_starts_in }) > 0;
                let showMaxToggle = (api_response_data.is_prize_reset == 1 && minDiff) ? false : (prizeListVar && prizeListVar.length > 0);
                this.setState({
                    showMaxToggle: showMaxToggle,
                    maxcurrentStatus: (api_response_data.is_prize_reset == 1 && minDiff ) ? false : true
                })
            })
            ls.set('selectedSports', api_response_data.sports_id);
            Constants.setValue.setAppSelectedSport(api_response_data.sports_id);
            if (WSManager.loggedIn() && this.state.contestStatus !== 1 && this.state.contestStatus !== 2) {
                this.getUserJoinCount(data);
            }
            else {
                this.setState({
                    joinBtnVisibility: (this.state.contestStatus !== 1 && this.state.contestStatus !== 2)
                })
            }
        }
    }

    getFixtureMiniLeagueApi = async () => {
        if (Constants.AppSelectedSport == null)
            return;

        let param = {
            "sports_id": Constants.AppSelectedSport,
            "season_game_uid": this.props.LobyyData.season_game_uid ? this.props.LobyyData.season_game_uid : this.state.season_game_uid
        }

        delete param.limit;
        var api_response_data = await getFixtureMiniLeague(param);
        if (api_response_data) {
            this.setState({
                MiniLeagueList: api_response_data.data
            }, () => {
                this.state.MiniLeagueList && this.state.MiniLeagueList.length == 1 &&
                    this.getMiniLeagueDetails(this.state.MiniLeagueList[0].mini_league_uid)
            })
        }
    }

    getMiniLeagueDetails = async (mini_league_uid) => {
        if (Constants.AppSelectedSport == null)
            return;

        let param = {
            "sports_id": Constants.AppSelectedSport,
            "mini_league_uid": mini_league_uid
        }

        delete param.limit;
        var api_response_data = await getMiniLeagueDetails(param);
        if (api_response_data) {
            this.setState({
                miniLeagueprizeList: api_response_data.data.prize_distibution_detail,
                miniLeagueMerchandiseList: api_response_data.data.merchandise,
            })
        }
    }

    getUserJoinCount(data) {
        var param = {
            "contest_id": data.contest_id,
        }
        this.setState({ isLoading: true })
        if(this.props.OpenContestDetailFor && this.props.OpenContestDetailFor.is_network_contest && this.props.OpenContestDetailFor.is_network_contest == 1){
            getUserContestJoinCountNetworkfantasy(param).then((responseJson) => {
                this.setState({ isLoading: false })
                if (responseJson.response_code == WSC.successCode) {
                    this.setState({ userJoinCount: responseJson.data.user_joined_count }, () =>
                        this.getIsTimerOver(this.state.ContestDetail))
                }
            })
        }
        else{
            getUserContestJoinCount(param).then((responseJson) => {
                this.setState({ isLoading: false })
                if (responseJson.response_code == WSC.successCode) {
                    this.setState({ userJoinCount: responseJson.data.user_joined_count }, () =>
                        this.getIsTimerOver(this.state.ContestDetail))
                }
            })
        }
    }

    getUserList(data = {}, page_no = 1) {
        var param = {
            "contest_id": data.contest_id,
            "page_no": page_no,
            "page_size": this.state.limit,
        }

        let IsNetworkFantasy = this.props.OpenContestDetailFor && this.props.OpenContestDetailFor.is_network_contest && this.props.OpenContestDetailFor.is_network_contest == 1;

        if(IsNetworkFantasy){
            param['collection_master_id'] = data.network_collection_master_id            
        }
        else{
            param['collection_master_id'] = data.collection_master_id
        }

        this.setState({ isLoadMoreLoaderShow: page_no > 1, isLoading: true })
        if(IsNetworkFantasy){
            getContestUserListNetworkfantasy(param).then((responseJson) => {    
                setTimeout(() => {
                    this.setState({ isLoading: false })
                }, 100);
                if (responseJson.response_code == WSC.successCode) {
                    let mergeList = [];
                    if (page_no == 1) {
                        mergeList = responseJson.data.users;
                        this.setState({ total_user_joined: responseJson.data.total_user_joined })
                    }
                    else {
                        mergeList = [...this.state.userList, ...responseJson.data.users]
                    }
                    hasMore = responseJson.data.users.length === this.state.limit;
                    this.setState({ userList: mergeList, page_no: this.state.page_no + 1 })
                }
            })
        }
        else{
            getContestUserList(param).then((responseJson) => {    
                setTimeout(() => {
                    this.setState({ isLoading: false })
                }, 100);
                if (responseJson.response_code == WSC.successCode) {
                    let mergeList = [];
                    if (page_no == 1) {
                        mergeList = responseJson.data.users;
                        this.setState({ total_user_joined: responseJson.data.total_user_joined })
                    }
                    else {
                        mergeList = [...this.state.userList, ...responseJson.data.users]
                    }
                    hasMore = responseJson.data.users.length === this.state.limit;
                    this.setState({ userList: mergeList, page_no: this.state.page_no + 1 })
                }
            })
        }
    }

    getWinnerCount(prizeDistributionDetail) {
        if (prizeDistributionDetail.length > 0) {
            if ((prizeDistributionDetail[prizeDistributionDetail.length - 1].max) > 1) {
                return prizeDistributionDetail[prizeDistributionDetail.length - 1].max + " " + AppLabels.WINNERS
            } else {
                return prizeDistributionDetail[prizeDistributionDetail.length - 1].max + " " + AppLabels.WINNER
            }
        }
    }

    joinGame() {
        this.props.history.push({ pathname: '/lineup' })
    }

    contestDetailBtnVisibility(contestDetailsState) {
        let totalUserJoined = parseInt(this.state.total_user_joined)
        let maxContestSize = parseInt(contestDetailsState.size)
        let userJoinedCount = this.state.userJoinCount;
        let multiLineupCount = parseInt(contestDetailsState.multiple_lineup)

        if (isTimerOver) {
            this.setState({
                joinBtnVisibility: false,
                showError: this.props.showPCError
            })
        } else {
            if (totalUserJoined >= maxContestSize) {
                this.setState({
                    joinBtnVisibility: false,
                    showError: this.props.showPCError
                })
            } else {
                if ((this.state.contestStatus && this.state.contestStatus == Constants.CONTEST_UPCOMING) || (this.state.ContestDetail.status == Constants.CONTEST_UPCOMING)) {
                    if ((multiLineupCount == 0 || multiLineupCount == 1) && userJoinedCount == 0) {
                        this.setState({
                            joinBtnVisibility: (this.state.contestStatus !== 1 && this.state.contestStatus !== 2),
                            showError: this.props.showPCError
                        })
                    } else if (multiLineupCount > 1 && (userJoinedCount < multiLineupCount)) {
                        this.setState({
                            joinBtnVisibility: (this.state.contestStatus !== 1 && this.state.contestStatus !== 2),
                            showError: this.props.showPCError
                        })
                    } else {   //New scenerio can be added here....
                        this.setState({
                            joinBtnVisibility: false,
                            showError: this.props.showPCError
                        })
                    }
                }
                else {
                    this.setState({
                        joinBtnVisibility: false,
                        showError: this.props.showPCError
                    })
                }
            }
        }
    }
    getIsTimerOver(contestDetailsState) {
        if (contestDetailsState.current_timestamp > contestDetailsState.game_starts_in) {
            isTimerOver = true;
        } else {
            isTimerOver = false;
        }
        this.contestDetailBtnVisibility(contestDetailsState)
    }

    onLoadMore = () => {
        if (!this.state.isLoading && hasMore)
            this.getUserList(this.props.OpenContestDetailFor, this.state.page_no);
    }

    ontabSelect = (tab) => {
        if (tab == 3) {
            if (this.state.userList.length == 0)
                this.getUserList(this.props.OpenContestDetailFor, 1);
        }
    }
    getContestPrizeDetails = (ContestDetail) => {
        this.setState({
            isMiniLeaguePrize: false,
        }, () => {
            this.props.history.push({
                pathname: '/all-prizes/' + "contestPrize" + "/" + false, state: {
                    LobyyData: this.state.LobyyData,
                    MiniLeagueData: ContestDetail,
                    isMiniLeaguePrize: this.state.isMiniLeaguePrize

                }
            })
        })
    }
    getPrizeDetail = (item, LobyyData) => {
        this.setState({
            isMiniLeaguePrize: true,
        }, () => {
            this.props.history.push({
                pathname: '/all-prizes/' + item.mini_league_uid + "/" + true, state: {
                    LobyyData: this.state.LobyyData,
                    MiniLeagueData: item,
                    isMiniLeaguePrize: this.state.isMiniLeaguePrize

                }
            })
        })
    }

    showPrivateContestError = () => {
        this.setState({
            showError: false
        }, () => {
            Utilities.showToast(AppLabels.ERROR_MSG, 5000);
        })
    }
    setCurrentMaxPrize = (minMaxValue, prizeItem) => {
        var finalPrize;
        var maxMini;
        if (prizeItem.prize_type == 2) {
            maxMini = prizeItem.max - prizeItem.min + 1;
            finalPrize = (Math.ceil(minMaxValue) / maxMini)
        } else {
            maxMini = prizeItem.max - prizeItem.min + 1;
            finalPrize = (parseFloat(minMaxValue).toFixed(2) / maxMini)
        }

        return finalPrize;
    }
    getWinnerCounts(prizeList) {

        if (prizeList != '') {
            if ((prizeList[prizeList.length - 1].max) > 1) {
                return prizeList[prizeList.length - 1].max + " " + AppLabels.WINNERS
            } else {
                return prizeList[prizeList.length - 1].max + " " + AppLabels.WINNER
            }
        } else {
            return '0 Winner';
        }
    }

    getPrizeAmount = (prize_data) => {
        let is_tie_breaker = 0;
        let prizeAmount = { 'real': 0, 'bonus': 0, 'point': 0 };
        return (
            <React.Fragment>
                {
                    prize_data && prize_data.map(function (lObj, lKey) {
                        var amount = 0;
                        if (lObj.max_value) {
                            amount = parseFloat(lObj.max_value);
                        } else {
                            amount = parseFloat(lObj.amount);
                        }
                        if (lObj.prize_type == 3) {
                            is_tie_breaker = 1;
                        }
                        if (lObj.prize_type == 0) {
                            prizeAmount['bonus'] = parseFloat(prizeAmount['bonus']) + amount;
                        } else if (lObj.prize_type == 2) {
                            prizeAmount['point'] = parseFloat(prizeAmount['point']) + amount;
                        } else {
                            prizeAmount['real'] = parseFloat(prizeAmount['real']) + amount;
                        }
                    })
                }

                {
                    is_tie_breaker == 0 && prizeAmount.real > 0 ?
                        <span className="contest-prizes">{Utilities.getMasterData().currency_code}{parseFloat(prizeAmount.real).toFixed(0)}</span>
                        : is_tie_breaker == 0 && prizeAmount.bonus > 0 ? <span className="contest-prizes margin-contest"><i className="icon-bonus" />{parseFloat(prizeAmount.bonus).toFixed(0)}</span>
                            : is_tie_breaker == 0 && prizeAmount.point > 0 ? <span style={{ marginLeft: '13px', display: 'inlineBlock' }}> <img alt='' className="img-coin" src={Images.IC_COIN} />{parseFloat(prizeAmount.point).toFixed(0)}</span>
                                : AppLabels.PRIZES
                }

            </React.Fragment>
        )


    }
    render() {
        const { IsContestDetailShow, IsContestDetailHide, onJoinBtnClick, LobyyData, OpenContestDetailFor } = this.props;
        const { ContestDetail, normal_scoring_rules, bonus_scoring_rules, economy_scoring_rules, pitching_scoring_rules, hitting_scoring_rules, strike_scoring_rules, prizeDistributionDetail, playerCount, joinBtnVisibility, userList, sportsSelected, allowCollection, showCollectionInfo, showError, isPrivateContest, showMaxToggle, tdsNotesObj } = this.state;

        let lengthFixture = LobyyData.match_list ? LobyyData.match_list.length : 0
        let match_item = lengthFixture >= 1 ? LobyyData.match_list[0] : LobyyData
        let sponserImage = ContestDetail.sponsor_logo && ContestDetail.sponsor_logo != null ? ContestDetail.sponsor_logo : 0
        let miniLeagueListLengthStatus = this.state.MiniLeagueList && this.state.MiniLeagueList.length > 1 ? 2 : this.state.MiniLeagueList && this.state.MiniLeagueList.length == 1 ? 1 : 0

        var isPrivateEnable = process.env.REACT_APP_PRIVATE_CONTEST_WINNING_DISABLE == 1 ? 1 : 0;
        var showtab = isPrivateContest == 1 ? (process.env.REACT_APP_PRIVATE_CONTEST_WINNING_DISABLE == 1 ? false : true) : true;
        console.log(normal_scoring_rules,"normal_scoring_rules");
        let language = WSManager.getAppLang();
        let tdsNotes = tdsNotesObj[language] ? tdsNotesObj[language].tds_notes : [];

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div>
                        <Modal show={IsContestDetailShow}
                            className={"contest-detail-dialog" + (showCollectionInfo ? ' contest-detail-hide' : ' ')}
                            onHide={IsContestDetailHide} bsSize="large"
                            dialogClassName={"contest-detail-modal primary-h contest-details-modal-white-lebel " + (!joinBtnVisibility ? 'contest-detail-with-btn' : '') + (isPrivateEnable == 1 && isPrivateContest == 1 ? ' contest-with-two-tabs' : '') +
                                (
                                    LobyyData ? (LobyyData.match_list && LobyyData.match_list.length > 1 ? 'contest-detail-with-collection' : '') :
                                        (ContestDetail.match_list && ContestDetail.match_list.length > 1 ? 'contest-detail-with-collection' : '')
                                )
                            }>
                            <Modal.Header className={LobyyData ? (LobyyData.match_list && LobyyData.match_list.length > 1 ? 'header-with-collection' : '') : (ContestDetail.match_list && ContestDetail.match_list.length > 1 ? 'header-with-collection' : '')}>
                                <Modal.Title >
                                    <a href onClick={IsContestDetailHide} className="modal-close">
                                        <i className="icon-close"></i>
                                    </a>
                                    <div className="match-heading header-content">
                                        {Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                            <div className="team-img-block">
                                                <img src={Utilities.teamFlagURL(match_item.home_flag || ContestDetail.home_flag)} alt="" />
                                            </div>
                                        }
                                        <div className="team-header-detail">
                                            {Constants.SELECTED_GAMET != Constants.GameType.MultiGame ?
                                                <div className="team-header-content text-uppercase">
                                                    <span>{match_item.home || ContestDetail.home} <span className='text-lowercase'> {AppLabels.VS} </span>{match_item.away || ContestDetail.away}</span>
                                                </div>
                                                :
                                                <div className="team-header-content ">
                                                    <span>{LobyyData.collection_name} </span>
                                                </div>
                                            }
                                            {
                                                this.state.contestStatus !== Constants.CONTEST_LIVE && <div className="match-timing">
                                                    {
                                                        (Utilities.showCountDown(LobyyData ? LobyyData : ContestDetail) && this.state.contestStatus !== Constants.CONTEST_COMPLETED) ?
                                                            <div className="countdown">
                                                                {
                                                                    LobyyData && LobyyData.game_starts_in ?
                                                                        <CountdownTimer deadlineTimeStamp={LobyyData.game_starts_in} />
                                                                        :
                                                                        ContestDetail && ContestDetail.game_starts_in ?
                                                                            <CountdownTimer deadlineTimeStamp={ContestDetail.game_starts_in} />
                                                                            :
                                                                            ''
                                                                }

                                                            </div>
                                                            :
                                                            <span className="time-line"> <MomentDateComponent data={{ date: (LobyyData ? LobyyData.season_scheduled_date : ContestDetail.season_scheduled_date), format: "D MMM - hh:mm A " }} /> </span>

                                                    }
                                                </div>
                                            }
                                        </div>
                                        {Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                            <div className="team-img-block">
                                                <img src={Utilities.teamFlagURL(match_item.away_flag || ContestDetail.away_flag)} alt="" />
                                            </div>
                                        }

                                    </div>

                                </Modal.Title>
                                 {(!WSManager.loggedIn() || joinBtnVisibility) &&
                                    <div className="header-section-contest-entry">
                                        {/* <div className="center-alignment">
                                            {
                                                ContestDetail.sponsor_logo && ContestDetail.sponsor_logo != "" && ContestDetail.sponsor_logo != null &&
                                                <div className="sponser-section-strip-header">
                                                    <span className="text-entry">{AppLabels.SPONSORED_BY}</span>
                                                    {


                                                        <div className="sponser-logo-view">


                                                            {
                                                                window.ReactNativeWebView ?
                                                                    <a
                                                                        href
                                                                        onClick={(event) => Utilities.callNativeRedirection(Utilities.getValidSponserURL(ContestDetail.sponsor_link, event))}>
                                                                        <img alt='' className="lobby_sponser-image sponser-card-image" style={{ resizeMode: 'contain' }} src={sponserImage == 0 ? Images.BRAND_LOGO_FULL_PNG : Utilities.getSponserURL(sponserImage)} />
                                                                    </a>

                                                                    :
                                                                    <a
                                                                        href={Utilities.getValidSponserURL(ContestDetail.sponsor_link)}
                                                                        onClick={(event) => event.stopPropagation()}
                                                                        target='__blank'>
                                                                        <img alt='' className="lobby_sponser-image sponser-card-image" style={{ resizeMode: 'contain' }} src={sponserImage == 0 ? Images.BRAND_LOGO_FULL_PNG : Utilities.getSponserURL(sponserImage)} />
                                                                    </a>

                                                            }

                                                        </div>
                                                    }
                                                </div>
                                            }

                                        </div> */}
                                          <div className="center-alignment">
                                            <span className="entry-fee-btn" onClick={() => onJoinBtnClick(ContestDetail)}>      
                                                {
                                                    ContestDetail.entry_fee > 0 ?
                                                        <>
                                                            {
                                                                ContestDetail.currency_type == 2 ?
                                                                    <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                                    :
                                                                    Utilities.getMasterData().currency_code
                                                            }
                                                            {ContestDetail.entry_fee} {AppLabels.JOIN}
                                                        </>
                                                        : 
                                                            AppLabels.JOIN_FOR_FREE
                                                }
                                            </span>

                                        </div>
                                    </div>
                                }

                            </Modal.Header>
                            {
                                this.state.ContestDetail.custom_message != '' && this.state.ContestDetail.custom_message != null && <div style={{marginTop:5,marginBottom:5,paddingLeft:15,paddingRight:15}} className="m-b-15 padding-strip">
                                    <Alert variant="warning" className="alert-warning msg-alert-container">
                                        <div className="msg-alert-wrapper">
                                            <span className=""><i className="icon-megaphone"></i></span>
                                            <span>{this.state.ContestDetail.custom_message}</span>
                                        </div>
                                    </Alert>
                                </div>
                            }
                            <Modal.Body>
                                <Tabs id={'contest-detail-tab'} onSelect={this.ontabSelect} defaultActiveKey={this.props.activeTabIndex} >
                                    {
                                        showtab &&
                                        <Tab eventKey={1} title={AppLabels.WINNINGS}>
                                            {


                                                Constants.SELECTED_GAMET == Constants.GameType.Free2Play ?
                                                    <div>
                                                        <div className="free-to-play-info margin-top_wiining">

                                                            <div className="text_hall_of_fame">
                                                                {AppLabels.SPONSORED_BY}
                                                            </div>
                                                            {
                                                                window.ReactNativeWebView ?
                                                                    <a
                                                                        href
                                                                        onClick={(event) => Utilities.callNativeRedirection(Utilities.getValidSponserURL(ContestDetail.sponsor_link, event))}>
                                                                        <img alt='' className="lobby_sponser-image sponser-card-image" style={{ resizeMode: 'contain' }} src={sponserImage == 0 ? Images.BRAND_LOGO_FULL_PNG : Utilities.getSponserURL(sponserImage)} />
                                                                    </a>

                                                                    :
                                                                    <a
                                                                        href={Utilities.getValidSponserURL(ContestDetail.sponsor_link)}
                                                                        onClick={(event) => event.stopPropagation()}
                                                                        target='__blank'>
                                                                        <img alt='' className="lobby_sponser-image sponser-card-image" style={{ resizeMode: 'contain' }} src={sponserImage == 0 ? Images.BRAND_LOGO_FULL_PNG : Utilities.getSponserURL(sponserImage)} />
                                                                    </a>

                                                            }

                                                        </div>
                                                        {this.state.prizeList && this.state.prizeList.length > 0 &&
                                                            <div className="table-heading switch-text-align">
                                                                <div style={{ width: '100%', color: '#212121' }}>
                                                                    {AppLabels.Prize_Distribution + " - " + (this.getWinnerCounts(this.state.prizeList))}
                                                                </div>

                                                            </div>
                                                        }
                                                        {
                                                            this.state.prizeList && this.state.prizeList.length > 0 ?
                                                                <Row className="Ftp-prizes  no-margin p-v-ms mt20">
                                                                    {
                                                                        this.state.prizeList && this.state.prizeList.length > 0 && this.state.prizeList.slice(0, 3).map((item, index) => {
                                                                            return (
                                                                                <FtpPrizeComponent from={"ContestDetail"} prizeListitem={item} merchandiseList={this.state.merchandiseList} />

                                                                            );
                                                                        })
                                                                    }

                                                                </Row>
                                                                :
                                                                <div className="no-prize-text">{AppLabels.NO_PRIZES_FOR_THIS_CONTEST}</div>

                                                        }
                                                        {
                                                            this.state.prizeList && this.state.prizeList.length > 3 &&
                                                            <div className="show-more-prizes text-center" >
                                                                <div className="button button-primary-rounded padding-more" onClick={() => this.getContestPrizeDetails(this.state.ContestDetail)}>
                                                                    {AppLabels.VIEW_ALL_PRIZES}</div>
                                                            </div>
                                                        }

                                                        {
                                                            miniLeagueListLengthStatus != 0 &&
                                                            <div className="contest-section-detail">

                                                                <img alt='' src={Images.HALL_OF_FAME_SMALL_ICON} />
                                                                <div className="Ftp-prizes-label">{AppLabels.HALL_OF_FAME_JOIN_CONTEST_TEXT}</div>


                                                            </div>
                                                        }
                                                        {
                                                            miniLeagueListLengthStatus == 2 && this.state.MiniLeagueList.map((item, index) => {
                                                                return (
                                                                    <div className="league-list-all">

                                                                        <div className="sort-contest-wrapper mt10 p-t p-lr ">
                                                                            <div className="contest-detail-section no-border">
                                                                                <div className="league-name contest-detail-text">
                                                                                    {item.mini_league_name}

                                                                                </div>
                                                                                <div className="pull-right view-prize-all margin-less" onClick={() => this.getPrizeDetail(item)}>
                                                                                    {AppLabels.VIEW_ALL_PRIZES}
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                        {
                                                            miniLeagueListLengthStatus == 1 &&
                                                                this.state.miniLeagueprizeList && this.state.miniLeagueprizeList.length > 0 ?
                                                                <Row className="Ftp-prizes  no-margin p-v-ms mt20">
                                                                    {
                                                                        this.state.miniLeagueprizeList && this.state.miniLeagueprizeList.length > 0 && this.state.miniLeagueprizeList.slice(0, 3).map((item, index) => {
                                                                            return (
                                                                                <FtpPrizeComponent from={"ContestDetail"} prizeListitem={item} merchandiseList={this.state.miniLeagueMerchandiseList} />
                                                                                 );
                                                                        })
                                                                    }

                                                                </Row>
                                                                :
                                                                miniLeagueListLengthStatus != 0 &&
                                                                <div className="no-prize-text">{AppLabels.NO_PRIZES_FOR_THIS_LEAGUES}</div>
                                                        }
                                                        {
                                                            this.state.miniLeagueprizeList && this.state.miniLeagueprizeList.length > 3 &&
                                                            <div className="show-more-prizes text-center" onClick={() => this.getPrizeDetail(this.state.MiniLeagueList[0])}>
                                                                <div className="button button-primary-rounded padding-more">
                                                                    {AppLabels.VIEW_ALL_PRIZES}</div>
                                                            </div>
                                                        }
                                                    </div>
                                                    :
                                                    <div className="winning-section">
                                                        <div className="winning-tab-header">

                                                            <div className='winning-text'>{AppLabels.PRIZES}</div>


                                                            <div className='winning-right-section'>
                                                                {this.getPrizeAmount(this.state.prizeList)}
                                                                <div className="winner-count">{this.getWinnerCount(prizeDistributionDetail)}</div>
                                                            </div>

                                                        </div>
                                                        <div className="center-alignment">
                                            {
                                                ContestDetail.sponsor_contest_dtl_image &&
                                                <div className="sponser-section-strip-header sponser-img-sec">
                                                    {
                                                        <div className="sponser-logo-view">
                                                            {
                                                                window.ReactNativeWebView ?
                                                                    <a
                                                                        href
                                                                        onClick={(event) => Utilities.callNativeRedirection(Utilities.getValidSponserURL(ContestDetail.sponsor_link, event))}>
                                                                        <img alt='' className="lobby_sponser-image sponser-card-image" style={{ resizeMode: 'contain' }} src={Utilities.getSponserURL(ContestDetail.sponsor_contest_dtl_image)} />
                                                                    </a>

                                                                    :
                                                                    <a
                                                                        href={Utilities.getValidSponserURL(ContestDetail.sponsor_link)}
                                                                        onClick={(event) => event.stopPropagation()}
                                                                        target='__blank'>
                                                                        <img alt='' className="lobby_sponser-image sponser-card-image" style={{ resizeMode: 'contain' }} src={Utilities.getSponserURL(ContestDetail.sponsor_contest_dtl_image)} />
                                                                    </a>

                                                            }

                                                        </div>
                                                    }
                                                </div>
                                            }

                                        </div>
                                                        <div className={"table-heading" + (ContestDetail.is_tie_breaker == 0 ? '' : ' switch-text-align')}>
                                                            {
                                                                ContestDetail.is_tie_breaker == 0 ?
                                                                    <div style={{ float: 'left', width: '80%' }}>
                                                                        {AppLabels.DISTRIBUTION}
                                                                    </div>
                                                                    :
                                                                    <div style={{ width: '100%' }}>
                                                                        {AppLabels.DISTRIBUTION}
                                                                    </div>

                                                            }

                                                            {
                                                                ContestDetail.is_tie_breaker == 0 && showMaxToggle && 
                                                                ContestDetail.is_prize_reset != 1 &&
                                                                // Utilities.minuteDiffValue({ date: ContestDetail.game_starts_in }) < 0 &&
                                                                <div className="switch-container">
                                                                    <div className="switch" >
                                                                        <input type="radio" className="switch-input" name="view" value="week" id="week" defaultChecked />
                                                                        <label for="week" className="switch-label switch-label-off" onClick={() => this.isMaximumSelected(true)}>{AppLabels.MAXIMUM}</label>
                                                                        <input type="radio" className="switch-input" name="view" value="month" id="month" />
                                                                        <label for="month" className="switch-label switch-label-on" onClick={() => this.isMaximumSelected(false)}>{AppLabels.CURRENT}</label>
                                                                        <span className="switch-selection"></span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <Table responsive>
                                                            <tbody>

                                                                {
                                                                    ContestDetail.is_tie_breaker == 0 ?
                                                                        _Map(ContestDetail.prize_distibution_detail, (prizeItem, idx) => {
                                                                            if(showMaxToggle && !this.state.maxcurrentStatus && ContestDetail.total_user_joined){
                                                                                if(ContestDetail.total_user_joined == 0 && idx > 0){
                                                                                    return ''
                                                                                }else if(prizeItem.min > ContestDetail.total_user_joined && ContestDetail.total_user_joined > 0){
                                                                                    return ''
                                                                                }
                                                                            }
                                                                            return (
                                                                                <tr key={idx}>
                                                                                    <td>{prizeItem.min == prizeItem.max ? prizeItem.min : prizeItem.min + ' - ' + prizeItem.max}</td>
                                                                                    <React.Fragment>

                                                                                        <div>
                                                                                            {
                                                                                                prizeItem.prize_type ?

                                                                                                    (prizeItem.prize_type == 0) ?
                                                                                                        <div className='winning'>
                                                                                                            <span className="contest-prizes">
                                                                                                                {<i style={{ display: 'inlineBlock' }} className="icon-bonus"></i>}

                                                                                                                {parseFloat(this.state.maxcurrentStatus ? this.setCurrentMaxPrize(prizeItem.max_value, prizeItem) : this.setCurrentMaxPrize(prizeItem.min_value, prizeItem)).toFixed(0)}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        :
                                                                                                        (prizeItem.prize_type == 1) ?
                                                                                                            <div className='winning'>

                                                                                                                <span className="contest-prizes" style={{ display: 'inlineBlock' }}>{Utilities.getMasterData().currency_code}
                                                                                                                    {this.state.maxcurrentStatus ? this.setCurrentMaxPrize(prizeItem.max_value, prizeItem) : this.setCurrentMaxPrize(prizeItem.min_value, prizeItem).toFixed(0)}

                                                                                                                </span>

                                                                                                            </div>
                                                                                                            :
                                                                                                            (prizeItem.prize_type == 2) ?
                                                                                                                <div className='winning'>
                                                                                                                    {
                                                                                                                        <span className="contest-prizes" style={{ display: 'flex' }}>
                                                                                                                            <img style={{ marginTop: "5px" }} src={Images.IC_COIN} width="10px" height="10px" />
                                                                                                                            {parseFloat(this.state.maxcurrentStatus ?
                                                                                                                                this.setCurrentMaxPrize(prizeItem.max_value, prizeItem) : this.setCurrentMaxPrize(prizeItem.min_value, prizeItem)).toFixed(0)}
                                                                                                                        </span>
                                                                                                                    }

                                                                                                                </div>
                                                                                                                :
                                                                                                                (prizeItem.prize_type == 3) ?
                                                                                                                    <div className='winning'>
                                                                                                                        {<span className="contest-prizes" style={{ display: 'inlineBlock' }}>{this.state.maxcurrentStatus ? prizeItem.max_value : prizeItem.min_value}</span>}

                                                                                                                    </div> : ''

                                                                                                    :
                                                                                                    (ContestDetail.prize_type == 0) ?
                                                                                                        <React.Fragment>
                                                                                                            {(prizeItem.amount === "0" || prizeItem.amount === "0.00") ?
                                                                                                                <td className="text-right">{AppLabels.PRACTICE}</td>
                                                                                                                :
                                                                                                                <td className="text-right">
                                                                                                                    <span className="amt-type">
                                                                                                                        <i style={{ display: 'inlineBlock' }} className="icon-bonus"></i>
                                                                                                                    </span>
                                                                                                                    {prizeItem.amount}
                                                                                                                </td>
                                                                                                            }
                                                                                                        </React.Fragment>
                                                                                                        :
                                                                                                        (ContestDetail.prize_type == 1) &&
                                                                                                        <React.Fragment>
                                                                                                            {
                                                                                                                (prizeItem.amount === "0" || prizeItem.amount === "0.00") ?
                                                                                                                    <td className="text-right">{AppLabels.PRACTICE}</td>
                                                                                                                    :
                                                                                                                    <td className="text-right">
                                                                                                                        <span className="amt-type">
                                                                                                                            {Utilities.getMasterData().currency_code}
                                                                                                                        </span>
                                                                                                                        {this.convertIntoWhole(prizeItem.amount)}
                                                                                                                    </td>
                                                                                                            }
                                                                                                        </React.Fragment>
                                                                                            }

                                                                                        </div>
                                                                                    </React.Fragment>


                                                                                </tr>
                                                                            )
                                                                        })

                                                                        :
                                                                        ContestDetail.prize_distibution_detail
                                                                        &&
                                                                        <React.Fragment>
                                                                            {
                                                                                Constants.SELECTED_GAMET == Constants.GameType.DFS && ContestDetail.is_tie_breaker == 1 &&
                                                                                    <>
                                                                                        {
                                                                                            <Row className="Ftp-prizes no-margin p-v-ms">
                                                                                            {
                                                                                                ContestDetail.prize_distibution_detail && ContestDetail.prize_distibution_detail.length > 0 && ContestDetail.prize_distibution_detail.map((item, index) => {
                                                                                                    return (
                                                                                                        <FtpPrizeComponent from={"ContestDetail"} prizeListitem={item} merchandiseList={this.state.merchandiseList} />
    
                                                                                                    );
                                                                                                })
                                                                                            }
    
                                                                                        </Row>
                                                                                        }
                                                                                    </>
                                                                                       }
                                                                        </React.Fragment>

                                                                }

                                                                {
                                                                    (ContestDetail.consolation_prize && prizeDistributionDetail.length > 0) && <tr>
                                                                        <td>{(prizeDistributionDetail[prizeDistributionDetail.length - 1].max + 1) + ' - ' + ContestDetail.size}</td>
                                                                        <td className="text-right">
                                                                            <span className="amt-type">
                                                                                {
                                                                                    ContestDetail.consolation_prize.prize_type == 0
                                                                                        ?
                                                                                        <i className="icon-bonus" />
                                                                                        :
                                                                                        <img className="coin-img" src={Images.IC_COIN} alt="" />
                                                                                }
                                                                            </span>
                                                                            {ContestDetail.consolation_prize.value}
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </Table>
                                                        {ContestDetail.guaranteed_prize != 2 && ContestDetail.minimum_size != ContestDetail.size && ContestDetail.entry_fee > 0 &&
                                                            <div className="tab-description">

                                                                <span className='star'>
                                                                    <sup>*</sup>
                                                                </span>
                                                                {AppLabels.PRIZE_MSG1} {ContestDetail.minimum_size} {AppLabels.PRIZE_MSG2} {ContestDetail.max_prize_pool}.<br />
                                                                {AppLabels.PRIZE_MSG3} {ContestDetail.minimum_size} {AppLabels.PRIZE_MSG4}
                                                            </div>
                                                        }
                                                        {
                                                            ContestDetail.guaranteed_prize == 2 && ContestDetail.total_user_joined >= ContestDetail.minimum_size &&
                                                            <div className="tab-description">
                                                                {AppLabels.GUARANTEED_PRIZE_MSG4}
                                                            </div>
                                                        }
                                                        {/* {((ContestDetail.guaranteed_prize == 2 && (ContestDetail.total_user_joined < ContestDetail.minimum_size)) || (ContestDetail.guaranteed_prize != 2 && ContestDetail.minimum_size == ContestDetail.size)) &&
                                                            <div className="tab-description">
                                                                {AppLabels.GUARANTEED_PRIZE_MSG2} {ContestDetail.minimum_size} {AppLabels.GUARANTEED_PRIZE_MSG3}
                                                            </div>
                                                        }
                                                        {((ContestDetail.guaranteed_prize == 2) || !(ContestDetail.guaranteed_prize != 2 && ContestDetail.minimum_size == ContestDetail.size)) &&
                                                            <div className="tab-description">
                                                                {AppLabels.GUARANTEED_PRIZE_MSG1}
                                                            </div>
                                                        } */}
                                                        {
                                                            !this.state.maxcurrentStatus && ContestDetail.minimum_size > this.state.total_user_joined &&
                                                            <div className="tab-description p-0">
                                                                {AppLabels.THIS_WILL_BE_UPDATED} {ContestDetail.minimum_size} {AppLabels.PEOPLE_JOINED_THIS_CONTEST}
                                                            </div>
                                                        }
                                                        {/* {
                                                            ((ContestDetail.guaranteed_prize == 2 && parseFloat(ContestDetail.prize_pool) >= 10000) || ContestDetail.guaranteed_prize != 2) &&
                                                            <div className="tab-description p-0">
                                                                {AppLabels.TDS_TEXT}
                                                            </div>
                                                        } */}
                                                        {
                                                            tdsNotes.length > 0 &&
                                                                tdsNotes.map((element, index) =>
                                                                element.length < 2 ? (
                                                                    <div
                                                                    key={index}
                                                                    className="tab-description text-left"
                                                                    >
                                                                    {element[0].text}
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                    key={index}
                                                                    className="tab-description text-left"
                                                                    >
                                                                    {element.map((item) =>
                                                                        item.text
                                                                        ? item.text
                                                                        : item.var &&
                                                                            item.var == "contest.minimum_size"
                                                                        ? ContestDetail.minimum_size
                                                                        : ""
                                                                    )}
                                                                    </div>
                                                                )
                                                            )
                                                        }
                                                    </div>
                                            }

                                        </Tab>
                                    }
                                    <Tab eventKey={2} title={AppLabels.INFO}>
                                        <div className="info-section">
                                            {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && ((LobyyData && LobyyData.match_list && LobyyData.match_list.length > 1) || (ContestDetail.match_list && ContestDetail.match_list.length > 1)) &&
                                                <div className="collection-description">
                                                    <div className="collection-info cursor-pointer" onClick={this.CollectionInfoShow}>
                                                        <span>{AppLabels.COLLECTION}</span>
                                                        <i className="icon-info"></i>
                                                    </div>
                                                    {AppLabels.COLLECTION_CONTEST_DISCRIPTION}
                                                </div>
                                            }
                                            <div className="header-section">
                                                <div className="contest-type">
                                                    {
                                                        (ContestDetail.is_private == 1 || ((OpenContestDetailFor || '').is_private == 1)) &&
                                                        <div className='contest-item-container'>
                                                            <span className="featured-icon">p</span>
                                                            <span>{AppLabels.PRIVATE_CONTEST}</span>
                                                        </div>
                                                    }
                                                    {
                                                        (ContestDetail.multiple_lineup > 1 || ((OpenContestDetailFor || '').multiple_lineup > 1)) &&
                                                        <div className='contest-item-container'>
                                                            <span className="featured-icon">m</span>
                                                            <span>{AppLabels.MULTI_ENTRY_CONTEST}</span>
                                                            <div className='contest-type-description'>{util.format(AppLabels.MULTI_ENTRY_DISCRIPTION, (ContestDetail.multiple_lineup || OpenContestDetailFor.multiple_lineup))}</div>
                                                        </div>
                                                    }
                                                    {
                                                        ContestDetail.guaranteed_prize == 2 && parseInt(this.state.total_user_joined) >= parseInt(ContestDetail.minimum_size) &&
                                                        <div className='contest-item-container'>
                                                            <span className="featured-icon">g</span>
                                                            <span>{AppLabels.GUARANTEED_CONTEST}</span>
                                                            <div className='contest-type-description'>{AppLabels.GUARANTEED_DESCRIPTION}</div>
                                                        </div>
                                                    }
                                                    {
                                                        ContestDetail.is_confirmed == 1 && parseInt(this.state.total_user_joined) >= parseInt(ContestDetail.minimum_size) &&
                                                        <div className='contest-item-container'>
                                                            <span className="featured-icon">c</span>
                                                            <span>{AppLabels.CONFIRM_CONTEST}</span>
                                                            <div className='contest-type-description'>{AppLabels.CONFIRM_DESCRIPTION}</div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="contest-info">
                                                <p>
                                                    <span>{util.format(AppLabels.SUBMIT_PLAYERS_IN_BUDGET, playerCount)}</span>
                                                </p>
                                                <div className="salary-cap-text">
                                                    {AppLabels.SALARY_CAP}
                                                    <span>{Utilities.getMasterData().currency_code} {ContestDetail.salary_cap}</span>
                                                </div>
                                            </div>
                                            <div className="">
                                                <Panel id="collapsible-panel-example-1" defaultExpanded>
                                                    <Panel.Heading>
                                                        <Panel.Title></Panel.Title>
                                                        <a href>
                                                            {AppLabels.SCORING_RULES}
                                                        </a>
                                                    </Panel.Heading>
                                                    <Panel.Collapse>
                                                        <Panel.Body>
                                                            <Table responsive>
                                                                <thead>
                                                                    <tr>
                                                                        <th>{normal_scoring_rules && normal_scoring_rules.length > 0 ? AppLabels.NORMAL : ''}</th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>                                                                    
                                                                    {
                                                                        _Map(normal_scoring_rules, (item, idx) => {
                                                                            if(item.score_position == AppLabels.FANTASY_ASSIST_LABEL) {
                                                                                return(
                                                                                    <tr key={idx}>
                                                                                        <td className="" style={{ position:'relative' }}>
                                                                                            {item.score_position}
                                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={
                                                                                                    <Tooltip id="tooltip" className="tooltip-featured">
                                                                                                        <strong style={{ fontSize:10 }}>
                                                                                                            {AppLabels.FANTASY_ASSIST}<br/>
                                                                                                            {AppLabels.FANTASY_ASSIST_SUB1}<br/>
                                                                                                            {AppLabels.FANTASY_ASSIST_SUB2}<br/>
                                                                                                            {AppLabels.FANTASY_ASSIST_SUB3}<br/>
                                                                                                            {AppLabels.FANTASY_ASSIST_SUB4}
                                                                                                        </strong>
                                                                                                    </Tooltip>
                                                                                                }>
                                                                                                <span className="tooltip-icon" onClick={(e) => e.stopPropagation()}>i</span>
                                                                                            </OverlayTrigger>
                                                                                        </td>
                                                                                        <td className="text-right right-text">
                                                                                            {item.score_points}
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <tr key={idx}>
                                                                                        <td className="">
                                                                                            {item.score_position}
                                                                                        </td>
                                                                                        <td className="text-right right-text">
                                                                                            {item.score_points}
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            }
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </Table>
                                                            {
                                                                bonus_scoring_rules.length > 0 &&
                                                                <div>

                                                                    <Table responsive className="mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>{AppLabels.BONUS}</th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                _Map(bonus_scoring_rules, (item, idx) => {
                                                                                    return (
                                                                                        <tr key={idx}>
                                                                                            <td className="">
                                                                                                {item.score_position}
                                                                                            </td>
                                                                                            <td className="text-right right-text">
                                                                                                {item.score_points}
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </tbody>
                                                                    </Table>
                                                                    {
                                                                        (Utilities.getMasterData().c_point > 0 || Utilities.getMasterData().vc_point > 0) &&
                                                                        <Table responsive>
                                                                            <tbody>
                                                                                {Utilities.getMasterData().c_point > 0 &&
                                                                                    <tr>
                                                                                        <td>{AppLabels.CAPTAIN}</td>
                                                                                        <td className="text-right right-text">
                                                                                            {(sportsSelected != SportsIDs.badminton) 
                                                                                                ? 
                                                                                                masterDataResponse != null && 
                                                                                                <>
                                                                                                {
                                                                                                    masterDataResponse.c_point + ' X' 
                                                                                                }
                                                                                                </>
                                                                                                    : 
                                                                                                masterDataResponse != null && 
                                                                                                <>
                                                                                                    {
                                                                                                        masterDataResponse.vc_point + ' X'
                                                                                                    }
                                                                                                </>
                                                                                                }
                                                                                        </td>
                                                                                    </tr>
                                                                                }
                                                                                {Utilities.getMasterData().vc_point > 0 &&
                                                                                    (sportsSelected != SportsIDs.badminton) &&
                                                                                    <tr>
                                                                                        <td>{AppLabels.VICE_CAPTAIN}</td>
                                                                                        <td className="text-right right-text">
                                                                                            {
                                                                                                masterDataResponse != null && 
                                                                                                <>
                                                                                                {
                                                                                                    masterDataResponse.vc_point + ' X'
                                                                                                }
                                                                                                </>
                                                                                            }   
                                                                                        </td>
                                                                                    </tr>
                                                                                }


                                                                            </tbody>
                                                                        </Table>
                                                                    }
                                                                </div>
                                                            }
                                                            {
                                                                economy_scoring_rules.length > 0 &&
                                                                <Table responsive>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>{AppLabels.ECONOMY_RATE}</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            _Map(economy_scoring_rules, (item, idx) => {
                                                                                return (
                                                                                    <tr key={idx}>
                                                                                        <td className="">
                                                                                            {item.score_position}
                                                                                        </td>
                                                                                        <td className="text-right right-text">
                                                                                            {item.score_points}
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            }
                                                            {
                                                                pitching_scoring_rules.length > 0 &&
                                                                <Table responsive>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>{pitching_scoring_rules[0].scoring_category_name}</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            _Map(pitching_scoring_rules, (item, idx) => {
                                                                                return (
                                                                                    <tr key={idx}>
                                                                                        <td className="">
                                                                                            {item.score_position}
                                                                                        </td>
                                                                                        <td className="text-right right-text">
                                                                                            {item.score_points}
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            }
                                                            {
                                                                hitting_scoring_rules.length > 0 &&
                                                                <Table responsive>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>{hitting_scoring_rules[0].scoring_category_name}</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            _Map(hitting_scoring_rules, (item, idx) => {
                                                                                return (
                                                                                    <tr key={idx}>
                                                                                        <td className="">
                                                                                            {item.score_position}
                                                                                        </td>
                                                                                        <td className="text-right right-text">
                                                                                            {item.score_points}
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            }
                                                            {
                                                                strike_scoring_rules.length > 0 &&
                                                                <Table responsive>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>{AppLabels.STRIKE_RATE}</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            _Map(strike_scoring_rules, (item, idx) => {
                                                                                return (
                                                                                    <tr key={idx}>
                                                                                        <td className="">
                                                                                            {item.score_position}
                                                                                        </td>
                                                                                        <td className="text-right right-text">
                                                                                            {item.score_points}
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            }
                                                        </Panel.Body>
                                                    </Panel.Collapse>
                                                </Panel>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey={3} title={AppLabels.ENTRIES}>
                                        <div className="entries-section">
                                            <div className="progress-bar-default">
                                                <ProgressBar className={this.state.total_user_joined < ContestDetail.minimum_size ? 'danger-area' : ''} now={this.ShowProgressBar(this.state.total_user_joined, ContestDetail.minimum_size)} />
                                                <div className="progress-bar-value">
                                                    <span className="total-output">{this.state.total_user_joined}</span> / <span className="total-entries">{ContestDetail.size} {AppLabels.ENTRIES}</span>
                                                    <span className="min-entries">{AppLabels.MIN} {ContestDetail.minimum_size}</span>
                                                </div>
                                            </div>

                                            <InfiniteScroll
                                                dataLength={userList.length}
                                                next={this.onLoadMore}
                                                hasMore={!this.state.isLoading && hasMore}
                                                scrollableTarget='users-scroll-list'
                                            >
                                                <div className='user-table-container' id="users-scroll-list" >
                                                    <Table responsive>
                                                        <tbody className="table-body">
                                                            {
                                                                _Map(userList, (item, idx) => {
                                                                    return (
                                                                        idx < parseInt(ContestDetail.size) ?
                                                                            <tr key={idx}>
                                                                                <td className="user-entry">
                                                                                    {item.image === '' &&
                                                                                        <img src={Images.DEFAULT_USER} alt="" className="user-img" />
                                                                                    }
                                                                                    {item.image !== '' &&
                                                                                        <img src={Utilities.getThumbURL(item.image)} alt="" className="user-img" />
                                                                                    }
                                                                                    <div className="user-name">{item.name}</div>
                                                                                </td>
                                                                                {ContestDetail.multiple_lineup > 1 &&
                                                                                    <td className="text-right team-joined">{item.user_join_count != -1 && item.user_join_count}
                                                                                        <span>{item.user_join_count != -1 && (item.user_join_count > 1 ? ' ' + AppLabels.TEAMS : ' ' + AppLabels.TEAM)}</span>
                                                                                    </td>
                                                                                }
                                                                            </tr>
                                                                            :
                                                                            ''
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </Table>

                                                </div>
                                            </InfiniteScroll>

                                        </div>
                                    </Tab>

                                    {Constants.SELECTED_GAMET == Constants.GameType.MultiGame ? <Tab eventKey={4} title={AppLabels.FIXTURE_TAB}>


                                        <InfiniteScroll
                                            style={{ overflow: 'hidden !important' }}
                                            pullDownToRefresh={false}
                                            dataLength={LobyyData.match_list.length}
                                            scrollableTarget='test'>
                                            <div className="collection-list-wrapper">
                                                {
                                                    (LobyyData.match_list.length > 0 ?
                                                        LobyyData.match_list.map((item, index) => {
                                                            return (
                                                                <div className="fixture-card-wrapper  fixture-card-wrapper-lg">
                                                                    <div className="fixture-card-body display-table">
                                                                        <div className={"match-info-section"}>
                                                                            {WSManager.getPickedGameType() == Constants.GameType.MultiGame &&
                                                                                <div className="section-left">
                                                                                    <img src={Utilities.teamFlagURL(item.home_flag)} alt="" className="home-team-flag" />
                                                                                </div>
                                                                            }
                                                                            <div className="section-middle">
                                                                                {
                                                                                    WSManager.getPickedGameType() == Constants.GameType.MultiGame
                                                                                        ?
                                                                                        <div>
                                                                                            <span className="team-home">{item.home}</span>
                                                                                            <span className="vs-text">{AppLabels.VERSES}</span>
                                                                                            <span className="team-away">{item.away}</span>
                                                                                        </div>
                                                                                        :
                                                                                        <span className="team-home">{item.collection_name}</span>
                                                                                }
                                                                                {
                                                                                    this.state.contestStatus !== Constants.CONTEST_LIVE && <div className="match-timing">
                                                                                        {

                                                                                            Utilities.showCountDown(item) && this.state.contestStatus !== Constants.CONTEST_COMPLETED ?
                                                                                                <div className="countdown time-line">
                                                                                                    {item.game_starts_in && <CountdownTimer deadlineTimeStamp={item.game_starts_in} />}
                                                                                                </div> :
                                                                                                <span> <MomentDateComponent data={{ date: item.season_scheduled_date, format: "D MMM - hh:mm a " }} /></span>
                                                                                        }
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            {WSManager.getPickedGameType() == Constants.GameType.MultiGame &&
                                                                                <div className="section-right">
                                                                                    <img src={Utilities.teamFlagURL(item.away_flag)} alt="" className="away-team-flag" />
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className={"fixture-card-footer" + (item.league_name ? '' : ' justify-center')}>
                                                                        {item.league_name &&
                                                                            <div className="match-type">
                                                                                {item.league_name || item.league_abbr}
                                                                                {/* {this.state.sports_id === '7' &&
                                                                                    <span>- {MATCH_TYPE[item.format]}</span>
                                                                                } */}
                                                                            </div>
                                                                        }

                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        (LobyyData.match_list.length === 0) &&
                                                        <NoDataView
                                                            BG_IMAGE={Images.no_data_bg_image}
                                                            CENTER_IMAGE={Images.BRAND_LOGO_FULL}
                                                            MESSAGE_1={AppLabels.NO_FIXTURES_MSG1}
                                                            MESSAGE_2={AppLabels.NO_FIXTURES_MSG2}
                                                            onClick_2={this.joinContest}
                                                        />
                                                    )}
                                            </div>
                                        </InfiniteScroll>
                                    </Tab> : ''}

                                </Tabs>
                                {
                                    !joinBtnVisibility && showError && this.showPrivateContestError()
                                }
                            </Modal.Body>
                        </Modal>
                        {showCollectionInfo &&
                            <CollectionInfoModal IsCollectionInfoShow={showCollectionInfo} IsCollectionInfoHide={this.CollectionInfoHide} />
                        }
                    </div>
                )}
            </MyContext.Consumer>
        );
    }
}
